import React from 'react';
import ReactDOM from 'react-dom';
import Paper from '@material-ui/core/Paper';
import { Request, Notification, Util, runtime, Scroller } from '../../common';
import InfiniteScroll from "react-infinite-scroll-component";
import Backdrop,{Loading} from '../../components/Backdrop';
import DataBase from './Base';
import { CircularProgress, Radio, Fab } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';

class List extends DataBase {
  constructor(props) {
    super(props);

    this.state = {
        ...this.state,
      items: [],
      empty: true,
      over: false,//加载是否结束
      refreshing: false,
      bottomLoading: false //指示从底部加载
    };
      this.pageIndex = 1;
      this.loading = false;
  }


  renderHeader() {
      if (!this.props.header) return null;
      var obj = this.props.header();
      return obj;
  }

  renderLoading() {
    let {bottomLoading} = this.state;
    return (
      bottomLoading? this.loadingComponent() :null
    )
  }

  renderFooter() {
      var obj = this.props.ListFooterComponent ? this.props.ListFooterComponent() : null;
      return (
          this.state.over ? obj : null
      );
  }


  emptyComponent() {
      let {emptyText,ListEmptyComponent}=this.props;
      if (ListEmptyComponent) {
          return ListEmptyComponent();
      }

      if (emptyText) {
          return (<div className="d-flex justify-content-center align-items-center c-mh25">
              <p className="mb-0 c-text-s3 text-grey">{emptyText}</p>
          </div>);
      }

      return null;
  }

  onRefresh(){
      this.setState({
          manualRefresh:true
      },()=>{
        this.refresh(()=>{
            this.setState({
                manualRefresh:false
            });
        });
      });
  }

  wrapperSelect(row,index,renderItem,selectComponent){
    var key = this.getRowKey(row);
    const isSelected = this.isSelected(key);

    return <div className="d-flex flex-row w-100" onClick={e=>this.handleRowClick(e,key,row)}>
        <div  className="d-flex align-items-center justify-content-center pr-2">
            {selectComponent(key,row,isSelected)}
        </div>
        <div className="d-flex flex-column m-0 p-0 w-100">{renderItem(row,index)}</div>
    </div>
  }

  _renderItem(row,index,checkbox,radio){
    let {renderItem} = this.props;
    if(!renderItem) return null;
    if(checkbox){
        return this.wrapperSelect(row,index,renderItem,(key,row,isSelected)=>{
            return <Checkbox className="p-0" color="primary" checked={isSelected} onClick={e => this.handleTargetClick(e, key, row)} />
        });
    }
    else if(radio){
        return  this.wrapperSelect(row,index,renderItem,(key,row,isSelected)=>{
            return <Radio className="p-0" name={this.radioName} color="primary" checked={isSelected} onClick={e => this.handleTargetClick(e, key, row)} />
        });
    }
    else return renderItem(row,index);
 }


  renderBody(){
    let {itemSeparatorComponent} = this.props;
    let {items}=this.state;
    let checkbox = this.checkbox();
    let radio = this.radio();
     return <ul className="c-datatable-list-container d-flex flex-column m-0 p-0">
                {items.map((item, index) => (
                    <li key={index} className="d-flex flex-column m-0 p-0 w-100">
                        {itemSeparatorComponent?itemSeparatorComponent():null}
                        {this._renderItem(item,index,checkbox,radio)}
                    </li>
                ))}
            </ul>;
  }

  refresh(done) {
      if (this.loading){
          if(done) done();
          return;
      }

      if(this.state.manualRefresh)
        Backdrop.current.show();

      let complete = ()=>{
          if(this.state.manualRefresh)
            Backdrop.current.hide();
          if(done) done();
      }

      this.loading = true;
      this.pageIndex = 1;
      this.setState({
          refreshing: true,
          over: false
      });
      this._load({
          refresh: true,
          error: (e) => {
              complete();
              this.setState({
                  refreshing: false,
                  //error: e
              });
              alert(e);
              if (this.props.onError)
                  this.props.onError(e);
          },
          dataReceived: (result, refresh) => {
              if (this.props.dataReceived) {
                  this.props.dataReceived(result, refresh);
              }
          },
          callBack: (result) => {
              complete();
              this.setState({
                  refreshing: false
              });
              if (this.props.loaded)
                  this.props.loaded(result);

              if (this.props.refresh)
                  this.props.refresh();
          }
      });
  }




  bottomLoad() {
      if (this.state.over) return; //已经结束
      if (this.loading) return; //防止多次加载
      this.loading = true;
      if (this.props.page) {
          this.pageIndex++;
      }
      this.setState({
          bottomLoading: true
      });
      this._load({
          error: (e) => {
              this.setState({
                  bottomLoading: false
              });
              alert(e);
              if (this.props.onError)
                  this.props.onError(e);
          },
          dataReceived: (result, refresh) => {
              if (this.props.dataReceived)
                  this.props.dataReceived(result, refresh);
          },
          callBack: (result) => {
              this.setState({
                  bottomLoading: false
              });
              if (this.props.loaded)
                  this.props.loaded(result);
          }
      });
  }

  reload(p){
    p=p||{};
    let {type,item,position}=p;
    if(type==="add"){
      let {items} = this.state;
      if(!position) position = "top";
      if(position =="top") Util.insert(items,0,item);
      else if(position =="bottom") items.push(item);
      else Util.insert(items,position,item);  //不是英文，那么是数字，直接插入对应的位置
      this.setState({items});
    } else if(type==="update"){
        let {selected,items} = this.state;
        this.updateArray(selected,item);
        this.updateArray(items,item);
        this.setState({selected,items});
    }else if(type==="delete"){
        let {selected,items} = this.state;
        this.deleteArray(selected,item);
        this.deleteArray(items,item);
        this.setState({selected,items});
    }else{
        //其他情况下刷新
        this.load();
    }
  }

  load() {
      this.onRefresh();
  }

  _load(p) {
      if (!p) p = {};
      let {action,pageSize} = this.props;
      var url = action;
      var arg = this.getParams();
      arg.pageIndex = this.pageIndex;
      arg.pageSize = pageSize;

      var my = this;
      this.getRemoteData(url, arg,(result)=>{
          my.processSuccess(result,p);
      },(error)=>{
          my.processError(error,p);
      });
  }

  getRemoteData(url, arg,success,error) {
      let {data} = this.props;
      if(data){
          //指定了数据
          var r = {rows:data,pageIndex:1,dataCount:data.length};
          success(r);
      }
      else{
        Request({
            url: url,
            data: arg,
            before:()=>{
  
            },
            complete:()=>{
  
            },
            success:(r)=>{
                success(r);
            },
            error:(msg)=>{
                error(msg);
            }
        });
      }
     
  }

  processSuccess(result,p){
      if (this.isUnmounted()) return;
      
      if (p.dataReceived) {
          p.dataReceived.bind(this)(result, p.refresh);
      }

      this.pageIndex = result.pageIndex; //归位pageIndex
      var newData = result.rows || result.data;

      var data = this.state.items;
      if (p.refresh) {
          //如果是刷新列表，那么先清空
          data = [];
      }

      data = data.concat(newData);
      this.setState({
          items: data
      });

     
      this.onEmpty(data.length == 0);

      if (p.callBack) {
          p.callBack.bind(this)(result);
      }
      this.loading = false;


      if (newData.length < this.props.pageSize) {
          this.setState({
              over: true
          });
          return;
      }

      this.checkContinueLoad();
  }

  checkContinueLoad(){  //当加载的数据太少，没有达到底部时，会不能继续加载，此处修复该问题

    var list = ReactDOM.findDOMNode(this.refs.main);
    if(list.offsetHeight<=document.body.offsetHeight){
        this.bottomLoad(); //继续加载
    }
  }

  onEmpty(b) { //b:true 没有任何数据，b:false，有数据
      this.setState({
          empty: b
      });
      if (this.props.onEmpty)
          this.props.onEmpty(b);
  }

  processError(error,p){
      if (this.isUnmounted()) return;
      if (error) {
          this.loading = false;
          if (p.error) {
              p.error(error);
          }
          return;
      }
  }

  loadingComponent(){
    return <div className="d-flex flex-row w-100 align-items-center justify-content-center pt-3 pb-2 text-dark">
              <CircularProgress color="inherit" size={25} thickness={4} />
                <div className="ml-2 c-text-s2">正在加载</div>
            </div>;
  }

  endComponent(){
    return <h4>已到底线</h4>;
  }


  render() {
      let {over,items} = this.state;
      let {openRefresh,scrollableTarget} = this.props;
      return (
          <InfiniteScroll
              ref="main"
              dataLength={items.length}
              next={()=>{this.bottomLoad()}}
              hasMore={!over}
              scrollableTarget={scrollableTarget}
              // loader={this.loadingComponent()}
              // endMessage={this.endComponent()}
              //  pullDownToRefresh={openRefresh}
              //  pullDownToRefreshThreshold={120}
              //  pullDownToRefreshContent={<h3>下拉刷新</h3>}  这个组件的下拉刷新功能在手机模拟器上运行有问题，不知道在真实手机里如何，测试后再开通
              // releaseToRefreshContent={<h3>释放刷新</h3>}
              // refreshFunction={()=>{this.onRefresh(); }}
          >
          {this.renderHeader()}
          {over&&items.length==0?this.emptyComponent():this.renderBody()}
          {this.renderLoading()}
          {this.renderFooter()}
          </InfiniteScroll>
      )
  }

};


List.defaultProps = {
  pageSize: 10,
  page: true,
  emptyText:"暂无数据",
  openRefresh: true, //开启下拉刷新
  rowSelect: true
}


export default class DataList extends React.Component {
 
  constructor(props, context) {
    super(props, context);
  }

  selectMode(type){
    return this.list.selectMode(type);
  }

  load(){
      return this.list.load();
  }

  get(){
    return this.list.get();
  }

  set(items){
    return this.list.set(items);
  }


  reset(){
    return this.list.reset();
  }

  reload(p){
    return this.list.reload(p);
  }

  render(){
    let { className,renderItem,toolbar,scrollableTarget}= this.props;
    let p = {...this.props};
    delete p.toolbar;delete p.renderItem;

    return (
      <Paper elevation={0} className={`c-datagrid c-datalist ${className}`}>
        <List
          ref={(r)=>{ this.list =r; }}
          scrollableTarget={scrollableTarget}
          header={()=>{ return toolbar;}}
          renderItem={(data,index)=>{
            return renderItem?renderItem(data,index):null; }}
            {...p}
          />
      </Paper>
    );
    }

}

DataList.defaultProps = {
    scrollableTarget: Scroller.host,
    className:''
  }
  

